import { Group, SegmentedControl, Stack, Text } from "@mantine/core";
import { IconInvoice, IconUserDollar } from "@tabler/icons-react";
import { Navigate, replace, useNavigate, useParams } from "react-router-dom";
import SubscriptionPage from "./main/SubscriptionPage";
import Billing from "./billing/Billing";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useSessionStore } from "../../../../stores/UserStore";

const Subscription = () => {
  const lang = useLanguage((s) => s.language);
  const reseller = useSessionStore((s) => s.reseller);
  const { tab } = useParams();
  const navigate = useNavigate();

  return (
    <Stack gap={0} pr={48} pt={16} h={"calc(100vh - 96px)"}>
      <Group gap={"md"} mb={16}>
        <Text size="xl" fw={600} mr={"auto"}>
          {lang.settings.billing_title}
        </Text>

        <SegmentedControl
          size="md"
          w={500}
          ml={"auto"}
          value={tab}
          data={[
            {
              label: (
                <Group justify="center">
                  <IconUserDollar />

                  <Text>{lang.settings.subscription}</Text>
                </Group>
              ),
              value: "account",
            },
            {
              label: (
                <Group justify="center">
                  <IconInvoice />

                  <Text>{lang.settings.billing}</Text>
                </Group>
              ),
              value: "billing",
              // disabled:
              //   profile?.subscriptions?.payment_methods?.length === 0 ||
              //   !profile?.subscriptions?.payment_methods,
            },
          ]}
          onChange={(v) => {
            navigate(`/settings/subscription/${v}`);
          }}
        />
      </Group>

      {tab === "account" ? <SubscriptionPage /> : <Billing />}
    </Stack>
  );
};

export default Subscription;
